import { Component, OnInit, Compiler, TemplateRef, Renderer2 } from '@angular/core';
import { AuthLoginService } from '../../../user/services/auth-login.service';
import { Router } from '@angular/router';
import { LocalStorageService } from 'ngx-webstorage';
import { StatePersistService } from 'src/app/core/services/state-persist.service';
import { SharedService } from '../../services/shared.service';
import { GoogleAnalyticsService } from '../../services/google-analytics.service';
import { SharedConsts } from '../../constants';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { CartService } from 'src/app/cart/services/cart.service';
import { AlertService } from 'src/app/core/services/alert.service';
import { ProductService } from 'src/app/product/services/product.service';
import { environment } from 'src/environments/environment';
import { Subscription } from 'rxjs';
import { select, Store } from '@ngrx/store';
import { SharedState } from 'src/app/shared/store/reducers';
import { getConfig } from 'src/app/shared/store/selectors/shared.selectors';
import { CartModuleConsts } from 'src/app/cart/contants';

declare let ga :Function;
@Component({
    selector: 'header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    standalone: false
})
export class HeaderComponent implements OnInit {
  value = "";
  is_retailer:any=false;
  imagePath = environment.s3_path + '/' + environment.product_image_folder + '/'
  searchText = '';
  componentLoaded = false;
  miniCart: boolean = false;
  searchShow = true;
  isMobile = false;
  isTablet = false;
  isDesktop = false;
  miniCartApiSubscribe: any;
  hasCartValue = false
  onGoingsearchValue = '';
  productData: any;
  user: any;
  showCart = true;
  productList:any =[];
  removeProduct = {};
  bsModalRef: BsModalRef;
  removeHeading = '';
  removeItemsCount = 0;
  removeType = '';
  miniCartDetail: any;
  globalApiResponse: any;
  miniloader = false;
  cartDetail:any;

  getConfigSubscirber$!:Subscription;
  hasUploadOrderFilePermissions : boolean =false;

  constructor(private AuthloginService: AuthLoginService, private router: Router,
    private _compiler: Compiler,
    private statePersist: StatePersistService,
    private sharedService: SharedService, private googleAnalyticsService: GoogleAnalyticsService,
    private modalService: BsModalService, private cartService: CartService,
    private alertService: AlertService, private productService: ProductService,
    private renderer: Renderer2,
    private store:Store<SharedState>
  ) {
  }

  ngOnInit(): void {
    this.globalApiResponse = {};
    this.globalApiCall()
    if (this.router.url == '/mycart' || this.router.url == '/mycart/review' || this.router.url == '/mycart/order-summary') {
      this.showCart = false
    }
    this.handleWindowResize()
    this.miniCartDetail = {};

    if (this.showCart) {

      this.miniCartDetails()

    }

    this.searchShow = true
    this.productData = this.statePersist.getLocalStorage('product_data');
    if (this.productData && this.productData.search_keyword != '' && this.productData.search_keyword != undefined && this.productData.search_keyword != null) {
      this.searchText = this.productData.search_keyword
    }
    else {
      this.searchText = ''
    }


    if (this.router.url.includes('/profile/reset-password')) {
      this.searchShow = false;
    }
    else {
      this.searchShow = true
    }
    this.user = this.statePersist.getLocalStorage('currentUser')
    var selectedretailer = this.statePersist.getLocalStorage('selectedRetailer') || ''
    if ((this.user.is_telesales_user || this.user.is_sales_rep || this.user.is_head_office_user) && selectedretailer !== ''){
      this.is_retailer = false
    }
    else{
      this.is_retailer = true
    }
    this.searchShow = true
    this.productData = this.statePersist.getLocalStorage('product_data');
    if (this.productData && this.productData.search_keyword != '' && this.productData.search_keyword != undefined && this.productData.search_keyword != null) {
      this.searchText = this.productData.search_keyword
    }
    else {
      this.searchText = ''
    }
    this.statePersist.watchSearchStorage().subscribe(message => {
      this.searchShow = true
      this.productData = this.statePersist.getLocalStorage('product_data');
      if (this.productData && this.productData.search_keyword != '' && this.productData.search_keyword != undefined && this.productData.search_keyword != null) {
        this.searchText = this.productData.search_keyword
      }
      else {
        this.searchText = ''
      }
      this.statePersist.setLocalStorage('product_data', this.productData, 'product-data-update')

    })
    this.getConfigFromStore();
  }

 async getConfigFromStore(){
    const config_store$ = await this.store.pipe(select(getConfig));
    this.getConfigSubscirber$ = config_store$.subscribe(res=>{
      if(Object.keys(res).length){
        this.checkIfUploadFilePermission(res?.is_upload_order)
      }
    });
  }
  


  checkIfUploadFilePermission(hasPermission):void{
      this.hasUploadOrderFilePermissions = hasPermission;
  }


  ngAfterViewInit() {
    this.miniCartApiSubscribe = this.statePersist.miniCartObjectObser.subscribe((message: any) => {

      if (!this.hasCartValue) {
        if (this.showCart) {
          this.miniCartDetails()
        }
      }
    })
  }

  ngOnDestroy() {
    if (this.miniCartApiSubscribe) {
      this.miniCartApiSubscribe.unsubscribe()

    }

  }

  handleWindowResize() {
    const resolution = window.innerWidth;
    this.isMobile = resolution >= 320 && resolution <= 767;
    this.isDesktop = !this.isMobile && !this.isTablet;  // update state
  }

  searchProduct(event) {
    if (event.key === "Enter") {
      this.searchText = event.target.value.trim();
      this.applySearch(this.searchText)
    }
    else {
      this.onGoingsearchValue = event.target.value.trim();
      this.searchText = event.target.value.trim();
    }

  }

  clearSearch() {
    this.searchText = '';
    this.productData = this.statePersist.getLocalStorage('product_data')
    this.productData.search_keyword = '';
    this.statePersist.setLocalStorage('product_data', this.productData, 'product-data-update')
  }
  changeValue(event) {
    this.onGoingsearchValue = event.target.value.trim();
    this.searchText = event.target.value.trim();
  }

  redirectTo() {
    var url = 'mycart'
    this.googleAnalyticsService.eventEmitter(SharedConsts.VIEW_BASKET_EVENT, SharedConsts.GOOGLEANALYTICSS_EVENT_CATEGORY_NAME, SharedConsts.VIEW_BASKET_EVENT_ACTION, SharedConsts.GOOGLEANALYTICSS_EVENT_LABEL, SharedConsts.GOOGLEANALYTICSS_EVENT_VALUE);
    this.renderer.removeClass(document.body, 'no-scroll');
    this.router.navigate([url]);
  }

  getProductData() {
    let product_data
    if (this.statePersist.getLocalStorage('product_data') != null) {
      product_data = this.statePersist.getLocalStorage('product_data')
      product_data['search_keyword'] = this.searchText
      this.statePersist.setLocalStorage('product_data', product_data, 'product-data-update')
    }
    else {
      product_data = { 'search_keyword': this.searchText }
      this.statePersist.setLocalStorage('product_data', product_data, 'product-data-update')

    }
  }
  getProductDataFromOtherURl() {
    let product_data
    if (this.statePersist.getLocalStorage('product_data') != null) {
      product_data = this.statePersist.getLocalStorage('product_data')
      product_data['search_keyword'] = this.searchText
      this.statePersist.setLocalStorage('product_data', product_data, 'search')
    }
    else {
      product_data = { 'search_keyword': this.searchText }
      this.statePersist.setLocalStorage('product_data', product_data, 'search')

    }
  }
  applySearch(text) {
    this.searchText = text;
    if (this.router.url.includes('product/listing') && !this.router.url.includes('promotion')) {
      this.getProductData()
      return true
    }
    else {
      this.getProductDataFromOtherURl()
      this.router.navigate(['product/listing/All']);
    }
  }
  logout() {
    this.AuthloginService.signOut()
      .subscribe(
        response => {
          if (response.status === 401) {
            localStorage.clear();
            sessionStorage.clear();
            this._compiler.clearCache();
            this.router.navigate(['users/login']);
          }
          localStorage.clear();
          sessionStorage.clear();
          this._compiler.clearCache();
          this.router.navigate(['users/login']);
        },
        error => {
          if (error.error.status === 401) {
            localStorage.clear();
            sessionStorage.clear();
            this._compiler.clearCache();
            this.router.navigate(['users/login']);
          }
        }
      );
  }

  miniCartDetails(url?:any) {
    this.hasCartValue = true

    this.miniloader = true
    this.sharedService.getminiCart()
      .subscribe(
        response => {
          this.miniCartDetail = response.response;
          this.statePersist.setLocalStorage('mini_cart_details', this.miniCartDetail, 'change');
          this.miniloader = false;
          this.hasCartValue = false;
          if(url == '/promotion/product/listing/'){
            this.statePersist.emitPromotionProductsData('update promotion product list data')
          }else if(url == '/promotion/All'){
            this.statePersist.emitPromotionsData('update promotion list')
          }
        },
        error => { 
          if(url == '/promotion/product/listing/'){
            this.statePersist.emitPromotionProductsData('update promotion product list data')
          }else if(url == '/promotion/All'){
            this.statePersist.emitPromotionsData('update promotion list')
          }
        }
      );
  }

  globalApiCall() {
    this.sharedService.getGlobalValues()
      .subscribe(
        response => {
          this.globalApiResponse = response.response;
          this.statePersist.setLocalStorage('global_data', this.globalApiResponse, 'change');
        },
        error => { }
      );
  }

  openMiniCart() {
    this.miniCart = true;
    this.getCartItems()
    this.renderer.addClass(document.body, 'no-scroll');
  }

  closeMiniCart(){
    this.miniCart = false;
    this.cartDetail = {}
    this.productList = []
    this.renderer.removeClass(document.body, 'no-scroll');
  }

  getCartItems() {
    this.componentLoaded = false
    this.cartService.getMiniCartItems()
    .subscribe(
      data => {
        if (data.response) {
          if (data.status == 2212){
            this.alertService.error(data.response)
          }
          this.cartDetail = data.response
          const product_list = data.response.items;
          for (let i = 0; i < product_list.length; i++) {
            this.productList.push(product_list[i]);
          }

          if (data.response.out_of_stock_remove == 1){
            this.statePersist.emitmobileListCountDetails('mobile count change')
          }
        }
        this.componentLoaded = true;
      }
    );
  }


  removePopup(template: TemplateRef<any>, type, selectedProduct) {
    if(type != 'All'){
      
      this.removeProduct = selectedProduct
      this.removeType = type
      this.removeHeading = 'Are you sure you want to remove product from cart?'
    }
    else{
      this.removeProduct= {}
      this.removeType = ''
      this.removeHeading = 'Are you sure you want to remove products from cart?'
    }
    this.bsModalRef = this.modalService.show(template,  Object.assign({}, { class: 'modal-dialog-centered custom-modal confirm' }));
  }

  async biTrackingcalling(product, trackingid){
    let birecommendObj;
    birecommendObj =  {"sku":product.sku, "bi_recommendation_id" : product.recommendation_id, "bi_tracking_identifier": trackingid}
    
    this.productService.biRecommend(birecommendObj).subscribe(
      data => {})
    
  }

  removeItem(product, type){
    this.removeProduct = product
    this.removeType = type
    let fordata;
    if (this.removeType == 'All'){
      this.googleAnalyticsService.eventEmitter(SharedConsts.BASKET_REMOVE_ALL_EVENT, SharedConsts.GOOGLEANALYTICSS_EVENT_CATEGORY_NAME, SharedConsts.BASKET_REMOVE_ALL_EVENT_ACTION, SharedConsts.GOOGLEANALYTICSS_EVENT_LABEL, SharedConsts.GOOGLEANALYTICSS_EVENT_VALUE);
    }
    else{
      this.googleAnalyticsService.eventEmitter(SharedConsts.BASKET_REMOVE_CART_ITEM_EVENT, SharedConsts.GOOGLEANALYTICSS_EVENT_CATEGORY_NAME, SharedConsts.BASKET_REMOVE_ALL_EVENT_ACTION, SharedConsts.GOOGLEANALYTICSS_EVENT_LABEL, SharedConsts.GOOGLEANALYTICSS_EVENT_VALUE);
    }
    this.componentLoaded = false;
    fordata = {'item_id': product.item_id,'collect_totals':true}
    this.cartService.removeMinicartItem(fordata)
      .subscribe(
        data => {
          if(product.recommendation_id > 0){
            this.biTrackingcalling(product, CartModuleConsts.BI_TRACKING_IDENTIFIER_TOREMOVE)
          }
          if (data.response) {
            if (this.removeType == 'All'){
              this.statePersist.emitminiCartData('min cart update')
            }
            if(data.status == 1180){
              localStorage.setItem('closeStorInfoMessage', data.response.msg)
              document.getElementById("openclosedStoreInfo").click();
              const currentUrl = this.router.url;
              this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
                this.router.navigate([currentUrl]);
              });
            }
            else if (data.status == 2212){
              this.alertService.error(data.response)
            }
            else if (data.status == 2211 && this.removeType == 'list'){
              this.alertService.error(data.response)
              this.productList = [];
              this.getCartItems()
              // this.list api call again
            }
            else {
              this.productList = this.productList.filter(item => item.item_id !== product.item_id);
              let cartObj = this.cartDetail
              cartObj['total_qty'] = data.response.items_count
              cartObj['total_case'] = data.response.items_cases
              cartObj['net_amount'] = data.response.net_amount	
              this.cartDetail = cartObj
              this.alertService.success('Product removed.')

            }
            
            this.componentLoaded = true;
            this.callBackFunctions()
            this.statePersist.emitminiCartData('update mini cart')
            
          }
            
          }

      )

  }

  clearCart(){
    this.bsModalRef.hide();
    this.componentLoaded = false;
    this.googleAnalyticsService.eventEmitter(SharedConsts.BASKET_REMOVE_ALL_EVENT, SharedConsts.GOOGLEANALYTICSS_EVENT_CATEGORY_NAME, SharedConsts.BASKET_REMOVE_ALL_EVENT_ACTION, SharedConsts.GOOGLEANALYTICSS_EVENT_LABEL, SharedConsts.GOOGLEANALYTICSS_EVENT_VALUE);
    let obj ={};
    if (this.productList[0].recommendation_id >0){
      obj = {'bi_tracking_identifier':CartModuleConsts.BI_TRACKING_IDENTIFIER_TOREMOVE}
    }
    this.cartService.clearMiniCart(obj)
      .subscribe(
        data => {
          if (data.response) {
            if(data.status == 1180){
              localStorage.setItem('closeStorInfoMessage', data.response.msg)
              document.getElementById("openclosedStoreInfo").click();
            }
            else{
              this.removeItemsCount = this.productList.length
              this.productList = [];
              this.getCartItems()
              this.callBackFunctions()
              this.statePersist.emitminiCartData('update mini cart')
              this.alertService.success('Products removed.')

            }
            this.componentLoaded = true;
          }
            
          }

      )
  }

  callBackFunctions(){
    if (!this.router.url.includes('/promotion')   && this.router.url.includes('/product/listing')){
      this.statePersist.setLocalStorage('back-to-product-listing', true)
      this.statePersist.emitProductData('update product data')
    }
    else if (this.router.url.includes('/product/detail')){
      this.statePersist.emitProductDetailData('update product detail data')
    }
    else if (this.router.url.includes('/promotion/product/listing/')){
      this.miniCartDetails('/promotion/product/listing/')
      // this.statePersist.emitPromotionProductsData('update promotion product list data')
    }
    else if (this.router.url.includes('/promotion/All')){
      this.miniCartDetails('/promotion/All')
      // this.statePersist.emitPromotionsData('update promotion list')
    }
    else if (this.router.url.includes('/product/recommended-products')){
      this.statePersist.emitrecommendedProductsData('update recommended products')
    }
    else if (this.router.url.includes('/home')){
      this.statePersist.emitNewProductsData('update new product section on home page')
      this.statePersist.emithomepageRecommendedProductsData('update home page recommended section data')
      this.statePersist.emithomepagePromotionProductsData('update promotion on home page')
    }
  }

  removeonSpinnerPopup(template: TemplateRef<any>, selectedProduct, type) {
    this.removeProduct = selectedProduct
    this.removeHeading = 'Are you sure you want to remove product from cart?'
    this.bsModalRef = this.modalService.show(template,  Object.assign({}, { class: 'modal-dialog-centered custom-modal confirm' }));
  }

  qytUpdate(product, qyt, type, template: any) {
    if (qyt == 0){
      qyt = 1
      this.removeType = type
      for (let i = 0; i < this.productList.length; i++) {
        if (this.productList[i]['product_id'] == product.product_id) {
          this.productList[i]['item_qty'] = '0'
        }
      }
      this.removeItem(product, 'list');
    }
    else{
      this.statePersist.amendQtyGoogleanalyticsEvent()
      this.productService.qytUpdateV3({ 'item_id': parseInt(product.item_id), 'qty': qyt, 'collect_totals':true})
      .subscribe(
        data => {
          if (data.response) {
            if (data.status == 1169) {
                this.productList = this.productList.filter(item => item.item_id !== product.item_id);
              }
              else if(data.status == 2212){
                for (let i = 0; i < this.productList.length; i++) {
                  var qty = this.productList[i]['item_qty'];
                  if (this.productList[i]['product_id'] == product.product_id) {
                    this.productList[i]['item_qty'] = qty;
                  }
                }
                this.alertService.error(data.response)
              }
              else if(data.status == 1180){
                for (let i = 0; i < this.productList.length; i++) {
                  var qty = this.productList[i]['item_qty'];
                  if (this.productList[i]['product_id'] == product.product_id) {
                    this.productList[i]['item_qty'] = qty;
                  }
                }
                localStorage.setItem('closeStorInfoMessage', data.response.msg)
                document.getElementById("openclosedStoreInfo").click();
                const currentUrl = this.router.url;
                this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
                  this.router.navigate([currentUrl]);
                });
              }
              else if (data.status == 1163) {
                this.productList = this.productList.filter(item => item.item_id !== product.item_id);
              }
              else if (data.status == 2211){
                this.alertService.error(data.response)
                this.productList = [];
                this.getCartItems()
              }
              else {
                for (let i = 0; i < this.productList.length; i++) {
                  if (this.productList[i]['item_id'] == product.item_id) {
                    this.productList[i]['item_qty'] = qyt
                    this.productList[i]['row_total'] = data.response.row_total
                    this.productList[i]['margin'] = data.response.margin
                    this.productList[i]['price'] = data.response.price
                  }
                }
                let cartObj = this.cartDetail
                cartObj['total_qty'] = data.response.items_count
                cartObj['total_case'] = data.response.items_cases
                cartObj['net_amount'] = data.response.net_amount	
                this.cartDetail = cartObj

              }
             this.callBackFunctions()
              this.statePersist.emitminiCartData('update mini cart')
              this.statePersist.emitOrderDetailData('updae order Deatil')
            
          }

        }
      );
    }
    
  }

  redirectToProductList(){
     this.statePersist.setLocalStorage('product_data', {'brand_filter':''});
    this.router.navigate(['/product/listing/All'])
    this.closeMiniCart()
  }

  toInteger(value) {
    return parseInt(value)
  }

  cancleRequest(product){
    this.bsModalRef.hide()
      for (let i = 0; i < this.productList.length; i++) {
        if (this.productList[i]['product_id'] == product.product_id) {
          this.productList[i]['item_qty'] = '1'
        }
      }
    
  }

}
